import styled from 'styled-components'

export const Button = styled.button`
    width: 100%;
    border-radius: 20px;
    padding: 20px 0px 20px 10px;
    background-color: #FF8A00;
    border: none;
    color: white;
`;
